import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    Grid,
    Divider,
    Chip,
} from '@mui/material';

const SubscriptionPlanSelector = ({
                                      open,
                                      onClose,
                                      onSelect,
                                      selectedPriceId,
                                      currentPriceId,
                                  }) => {
    const [tempSelectedId, setTempSelectedId] = React.useState(null);

    React.useEffect(() => {
        if (!open) setTempSelectedId(null);
    }, [open]);

    // ✅ Hardcoded Stripe Price IDs
    const plans = [
        {
            label: 'Gold Plan',
            price: '$150/month',
            credits: '4 credits/month',
            priceId: 'prod_SNxHuh6Ha0WYk3',
            benefits: [
                'Perfect for light training schedules',
                'Save $10 vs buying 4 single credits',
            ],
        },
        {
            label: 'Platinum Plan',
            price: '$300/month',
            credits: '10 credits/month',
            priceId: 'prod_SNxHHgzEh1Dol7',
            benefits: [
                'Designed for committed athletes',
                'Save $100 vs buying 10 single credits',
            ],
            bestValue: true,
        },
    ];

    const handleContinue = () => {
        if (tempSelectedId) {
            onSelect(tempSelectedId);
            onClose();
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            PaperProps={{ style: { backgroundColor: '#121212', padding: '1rem' } }}
        >
            <DialogTitle
                style={{
                    color: '#fff',
                    textAlign: 'center',
                    fontSize: '1.75rem',
                    fontWeight: 600,
                }}
            >
                Select Your Subscription Plan
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={3}>
                    {plans.map((plan, idx) => {
                        const isCurrent = currentPriceId === plan.priceId;
                        const isSelected = tempSelectedId === plan.priceId;

                        return (
                            <Grid item xs={12} md={6} key={idx}>
                                <Box
                                    onClick={() => setTempSelectedId(plan.priceId)}
                                    sx={{
                                        position: 'relative',
                                        border: '2px solid #333',
                                        borderRadius: '16px',
                                        padding: '2rem',
                                        color: '#fff',
                                        backgroundColor: isSelected ? '#1a1a1a' : '#1e1e1e',
                                        boxShadow: isSelected
                                            ? '0px 0px 0px 2px #12c099 inset'
                                            : '0px 4px 20px rgba(0, 0, 0, 0.4)',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            backgroundColor: '#12c09910',
                                            transform: 'translateY(-3px)',
                                        },
                                    }}
                                >
                                    {plan.bestValue && (
                                        <Chip
                                            label="Best Value"
                                            size="small"
                                            sx={{
                                                position: 'absolute',
                                                top: 16,
                                                right: 16,
                                                backgroundColor: '#12c099',
                                                color: '#000',
                                                fontWeight: 600,
                                            }}
                                        />
                                    )}

                                    <Typography variant="h5" gutterBottom fontWeight={600}>
                                        {plan.label}
                                    </Typography>

                                    <Typography variant="h4" fontWeight={700} color="#12c099">
                                        {plan.price}
                                    </Typography>

                                    <Typography variant="subtitle1" gutterBottom>
                                        {plan.credits}
                                    </Typography>
                                    <Typography variant="caption" sx={{ color: '#aaa' }}>
                                        $
                                        {(
                                            parseInt(plan.price.replace('$', '').replace('/month', '')) /
                                            parseInt(plan.credits)
                                        ).toFixed(2)}
                                        /credit
                                    </Typography>

                                    <Divider sx={{ my: 2, borderColor: '#333' }} />

                                    {plan.benefits.map((point, i) => (
                                        <Typography key={i} variant="body2" sx={{ mb: 0.5, color: '#ccc' }}>
                                            • {point}
                                        </Typography>
                                    ))}

                                    {isCurrent && (
                                        <Typography
                                            variant="caption"
                                            sx={{ color: '#aaa', mt: 1, fontStyle: 'italic' }}
                                        >
                                            You’re currently on this plan
                                        </Typography>
                                    )}
                                </Box>
                            </Grid>
                        );
                    })}
                </Grid>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'space-between', mt: 2, px: 3 }}>
                <Button onClick={onClose} sx={{ color: '#999', fontWeight: 500 }}>
                    Cancel
                </Button>
                <Button
                    onClick={handleContinue}
                    disabled={!tempSelectedId}
                    variant="contained"
                    sx={{
                        backgroundColor: '#12c099',
                        color: '#000',
                        fontWeight: 600,
                        '&:hover': {
                            backgroundColor: '#10a088',
                        },
                    }}
                >
                    Continue
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SubscriptionPlanSelector;
